import React, { useEffect } from 'react';
import { BET_TYPES_NAMES, OWNER_BET_TYPE_T_KEYS, OWNER_CLASS } from '../../enums/cardOwner';
import { soundService } from '../../services/SoundService';

function WinPopup({ winningAmount, t, currencyCode, winType }) {
  useEffect(() => {
    if (winningAmount) {
      soundService.playWin();
    }
  }, [winningAmount]);

  return (
    <div className={`football-field-popup ${OWNER_CLASS[winType]}`}>
      {/* add class "home" "away" "draw" */}
      {winningAmount ? (
        <div className='football-field-win-holder'>
          <div className='football-field-win-block'>
            {t(OWNER_BET_TYPE_T_KEYS[BET_TYPES_NAMES[winType]])}
          </div>
          <p className='football-field-win-money'>
            {winningAmount} {currencyCode}
          </p>
        </div>
      ) : (
        <div className='football-field-win-market-holder'>
          <div className='football-field-win-block'>
            {t(OWNER_BET_TYPE_T_KEYS[BET_TYPES_NAMES[winType]])}
          </div>
        </div>
      )}
    </div>
  );
}

export default WinPopup;
